import styled from 'styled-components';
import {
  Col, Row,
} from 'antd';
import {
  primaryFont, wMedium, maxWidth, retina,
} from 'Utils/utilsStyle';
import CopyIcon from 'Components/common/assets/svgIcons/CopyIcon';
import { EmailShareButton } from 'react-share';
import SendIconRight from 'Components/common/assets/svgIcons/SendIconRight';
import { useEffect } from 'react';
import { getCurrentTime, getQueryPersonType, teamsShareLauncherFunction, valueToObject } from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCopyModalOpen, selectProfileShareLink } from 'Selector/ProfileShareSelector';
import { personCardPersonId, personProfileName } from 'Selector/PersonProfileSelector';

import { actions as helperActions } from 'Slice/HelperSlice';

import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { selectCompanyId, selectCompanyName } from 'Selector/CompaniesSelector';
import CopyToClipboardPopup from './CopyToClipboardPopup';
import { actions as shareActions } from '../../Slice/ProfileShareSlice';

const ContentWrapper = styled.div`
  .teams-share-button{
    display: flex;
    flex-direction: row-reverse;
    width: auto;
    height: 20px;
    margin-top: 0px;
    p{
      /* margin-left: 22px; */
    }
  }
  .icon {
    svg {
      height: 24px;
      width: 20px;
    }
  }

  .lowerPart{
    padding: 0 47px 20px 23px;
  }
  .userInfoSection {
    margin-top: 18px;
  }

  .linkMarginTop {
    padding-top: 18px;
  }
  .list-item {
    /* container styling */
    display: flex;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
    /* font styling */
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    letter-spacing: -0.4px;
    line-height: 24px;
    color: #7E7E7E;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
      line-height: 18px;
    }
    &:hover {
      cursor: pointer;
    }
    svg {
      margin-right: 10px;
    }
  }
`;

type Props = {
  subject: string,
  isPerson?: boolean,
} & typeof defaultProps;

const defaultProps = {
  isPerson: false,
};

const ProfileShareIcons = function ProfileShareIcons(props: Props) {
  const { subject, isPerson } = props;
  const personLink = useSelector(selectProfileShareLink);
  const personName = useSelector(personProfileName);
  const companyName = useSelector(selectCompanyName);
  const companyId = useSelector(selectCompanyId);
  const personId = useSelector(personCardPersonId);
  const isVisible = useSelector(selectCopyModalOpen);
  const dispatch = useDispatch();
  const host = window.location.href;

  const updatedUri = (link: string): string => {
    const trimSubject = subject.replace(/\s/g, '');
    const paramName = isPerson ? 'personName' : 'companyName';
    const optionalInfo = `?${paramName}=${trimSubject}`;

    return `${link}${optionalInfo}`;
  };

  const data = useSelector(selectData);

  useEffect(() => {
    teamsShareLauncherFunction();
  }, []);

  const certificationHandler = (isTeams = false) => {
    if (isPerson) {
      if (isTeams) {
        dispatch(helperActions.callFlurryEvent(
          valueToObject(
            'executive_profile_sendviateams',
            0,
            {
              person_id: personId,
              person_name: personName,
              type: getQueryPersonType(),
              host,
            },
          ),
        ));
      }
      dispatch(certificationActions.certificationAction({
        type: 'person_share_options',
        source: 'person',
        data,
      }));
    } else {
      dispatch(certificationActions.certificationAction({
        type: 'company_share_options',
        source: 'company',
        data,
      }));
    }
  };

  const copyHandle = async () => {
    await navigator.clipboard.writeText(updatedUri(personLink));
    dispatch(helperActions.setNotification({
      message: 'Link Copied!',
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
    }));
    certificationHandler();
    dispatch(helperActions.callFlurryEvent(
      valueToObject(
        isPerson ? 'executive_profile_sharelink_copy' : 'company_profile_sharelink_copy',
        0,
        isPerson ? {
          person_id: personId,
          person_name: personName,
          type: getQueryPersonType(),
          host,
        } : {
          company_id: companyId,
          company_name: companyName,
          host,
        },
      ),
    ));
  };

  const callFlurryEventFunc = () => {
    const startTime = getCurrentTime();
    dispatch(helperActions.callFlurryEvent(
      valueToObject(
        isPerson ? 'executive_profile_email_share' : 'company_profile_email_share',
        startTime,
        isPerson ? {
          person_id: personId,
          person_name: personName,
          type: getQueryPersonType(),
          host,
        } : {
          company_id: companyId,
          company_name: companyName,
          host,
        },
      ),
    ));
    certificationHandler();
  };

  const toggleCopyModal = () => {
    dispatch(shareActions.setCopyModalOpen(!isVisible));
  };

  return (
    <ContentWrapper>
      <div className="grid-checkbox-wrapper">
        <CopyToClipboardPopup
          isShowPopup={isVisible}
          onClickCancel={toggleCopyModal}
          url={updatedUri(personLink)}
          copyToClipboard={copyHandle}
        />
        <Row>
          <Col span={24}>
            <span
              tabIndex={0}
              role="button"
              onKeyPress={() => toggleCopyModal()}
              className="list-item"
              onClick={() => toggleCopyModal()}
            >
              <CopyIcon />
              Copy shareable Link
            </span>
            <div
              className="list-item"
              role="button"
              tabIndex={0}
              onClick={callFlurryEventFunc}
              onKeyPress={callFlurryEventFunc}
              aria-label="Calling "
            >
              <EmailShareButton
                subject={`${subject}'s xiQ Insights`}
                className="social-icons-slide-mail"
                url={updatedUri(personLink)}
                separator={'\r\n\r\n'}
              >
                <SendIconRight />
                Send via Email
              </EmailShareButton>
            </div>
            <div aria-hidden="true" className="list-item" onClick={() => { certificationHandler(true); }}>
              <div
                className="teams-share-button"
                data-preview
                data-href={updatedUri(personLink)}
                data-msg-text="Shared via - xiQ "
                data-icon-px-size="22"
              >
                <p>Send via MS Teams</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </ContentWrapper>
  );
};

ProfileShareIcons.defaultProps = defaultProps;
export default ProfileShareIcons;
